import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/youtube_icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-6e9c4228"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0" }, "Gerenciar perfil")
], -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "d-flex mb-3" }
const _hoisted_7 = { class: "position-relative" }
const _hoisted_8 = { class: "position-absolute avatar-content w-100 p-3 bottom-0" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_10 = { class: "badge bg-primary" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_12 = { class: "ms-3" }
const _hoisted_13 = {
  key: 0,
  class: "badge bg-success mb-2 rounded-4"
}
const _hoisted_14 = { class: "text-subtitle mb-2" }
const _hoisted_15 = { class: "text-label" }
const _hoisted_16 = { class: "text-paragraph" }
const _hoisted_17 = { class: "d-flex mb-4" }
const _hoisted_18 = { class: "border rounded-4 px-2 border-2 text-paragraph me-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-star text-warning" }, null, -1))
const _hoisted_20 = { class: "border rounded-4 px-2 border-2 text-paragraph" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user-group" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-3" }, null, -1))
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-12 col-md-6" }
const _hoisted_25 = { class: "col-12 col-md-6" }
const _hoisted_26 = { class: "card-body" }
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center justify-content-between mb-3\" data-v-6e9c4228><p class=\"mb-0 text-subtitle\" data-v-6e9c4228><i class=\"fa-solid fa-star\" data-v-6e9c4228></i> Melhore seu perfil </p><i class=\"fa-solid fa-chevron-right\" data-v-6e9c4228></i></div><p class=\"text-paragraph\" data-v-6e9c4228> Dicas para deixar seu perfil mais atrativo para os pacientes. </p>", 2)
const _hoisted_29 = { class: "progress" }
const _hoisted_30 = { class: "card" }
const _hoisted_31 = { class: "card-body" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-eye" }),
  /*#__PURE__*/_createTextVNode(" Visualizações ")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Quantidade de pacientes que visualizaram seu perfil. ", -1))
const _hoisted_34 = { class: "d-flex align-items-center justify-content-between border-bottom my-4" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, "Últimos 30 dias", -1))
const _hoisted_36 = { class: "text-subtitle" }
const _hoisted_37 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, "Todas visualizações", -1))
const _hoisted_39 = { class: "text-subtitle" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "mb-0 text-paragraph" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right ms-auto text-primary" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarComponent = _resolveComponent("AvatarComponent")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_AvatarComponent),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, "R$" + _toDisplayString(_ctx.session?.appointment_price), 1),
                  _hoisted_11
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.session?.online)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Disponível agora "))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.session?.name), 1),
              _createElementVNode("p", _hoisted_15, " CRP: " + _toDisplayString(_ctx.session?.crp) + " | " + _toDisplayString(_ctx.session?.address_state), 1)
            ])
          ]),
          _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.session?.bio), 1),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, [
              _hoisted_19,
              _createTextVNode(" " + _toDisplayString(_ctx.session?.ratings_as_psi_count), 1)
            ]),
            _createElementVNode("span", _hoisted_20, [
              _hoisted_21,
              _createTextVNode(" " + _toDisplayString(_ctx.session?.valid_appointments_as_psi_count), 1)
            ])
          ]),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_Button, {
                label: "Visualizar perfil",
                outline: "",
                fullWidth: "",
                onOnClick: _ctx.handleProfile
              }, null, 8, ["onOnClick"])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_Button, {
                label: "Editar perfil",
                color: "primary",
                fullWidth: "",
                onOnClick: _ctx.handleProfileEdit
              }, null, 8, ["onOnClick"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "card cursor-pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleImproveYourProfile && _ctx.handleImproveYourProfile(...args)))
      }, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", {
              class: "progress-bar bg-success",
              role: "progressbar",
              style: _normalizeStyle({
                width: `${_ctx.session?.profile_improvement_values?.percentage}%`,
              })
            }, null, 4)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.session?.total_views_this_month), 1)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.session?.total_views), 1)
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["d-flex align-items-center py-4 cursor-pointer", { 'border-bottom': index !== _ctx.actions.length - 1 }]),
          key: index,
          onClick: action.action
        }, [
          _createElementVNode("p", _hoisted_41, [
            _createElementVNode("i", {
              class: _normalizeClass([action.icon, "text-primary"])
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(action.label), 1)
          ]),
          _hoisted_42
        ], 10, _hoisted_40))
      }), 128))
    ])
  ]))
}